module.exports = __webpack_public_path__ + "static/media/John-Nate_2x.0a8de00f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/onboard/John-Nate_2x.png
// module id = 1151
// module chunks = 44